import ResponsiveImage from '../responsive-image';
import Link from 'next/link';

const Advertising = () => {
  return (
    <>
      <div className="py-5 background-white">
        <div className="container-xl pt-5">
          <div className="row align-items-center">
            <div className="col-sm-5 pe-sm-5 pb-5">
              <ResponsiveImage
                src="/images/home/making-proposal-at-table.jpg"
                alt="College Recruiter"
                className="rounded"
              />
            </div>
            <div className="col-sm-7 pb-5 ps-sm-5">
              <p className="mb-3 fs-5 text-red">
                <strong>Engage With Diverse, Early Career Talent</strong>
              </p>
              <h2 className="mb-4">
                Many of the world&apos;s largest employers use our permission-based, targeted email
                product to reach diverse students and recent grads by location, school, major,
                gender, race, LGBTQ, and more.
              </h2>
              <Link href="/employers#TargetedEmail" passHref>
                <a className="text-btn">Get Diverse Talent </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Advertising;
